/* ==========================================================================
   AIRFORMANCE X · Scratch & Win — guard v1 (oct 2026)
   Se carga ANTES de airformance-scratch-popup.js y no lo modifica.
   1) Cliente con sesión iniciada en la tienda  -> no se muestra el popup.
   2) Ya rascó en este navegador (cualquier campaña/landing) -> mismo premio,
      sin re-rascar; si ya desbloqueó el código, no se vuelve a mostrar.
   3) Perfil ya identificado por Klaviyo (viene de un email: suscriptor o
      cliente) -> no se muestra.
   Si algo falla, no hace nada y el popup funciona como siempre.
   Desactivar: borra la línea del guard en sections/airformance-scratch-popup.liquid
   ========================================================================== */
(function () {
  'use strict';
  var P = 'afx_scratch:';
  function lg(k) { try { return window.localStorage.getItem(P + k); } catch (e) { return null; } }
  function ls(k, v) { try { window.localStorage.setItem(P + k, v); } catch (e) {} }
  function ss(k, v) { try { window.sessionStorage.setItem(P + k, v); } catch (e) {} }
  function pj(r) { if (!r) return null; try { return JSON.parse(r); } catch (e) { return null; } }
  function hide(reason) {
    ss('closed', '1');
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'scratch_popup_suppressed', reason: reason });
    } catch (e) {}
  }

  try {
    if (window.Shopify && window.Shopify.designMode) return;
    if (/[?&]afx_preview=1/.test(window.location.search)) return;

    var flags = window.AFX_SCRATCH_GUARD || {};

    /* 1) Cliente logueado */
    if (flags.isCustomer) { ls('known', '1'); hide('customer'); return; }

    /* 2) Ya rascó en este navegador */
    var prev = null;
    try {
      for (var i = 0; i < window.localStorage.length; i++) {
        var key = window.localStorage.key(i);
        if (!key || key.indexOf(P + 'state:') !== 0) continue;
        var st = pj(window.localStorage.getItem(key));
        if (st && st.rewardId && st.code && (!prev || (st.unlocked && !prev.unlocked))) prev = st;
      }
    } catch (e) {}

    if (prev) {
      var cfgEl = document.querySelector('[data-afx-scratch] script[data-afx-config]');
      var cfg = cfgEl ? pj(cfgEl.textContent) : null;
      var mismatch = false;
      if (cfg && cfg.campaigns && cfg.campaigns.length) {
        cfg.campaigns.forEach(function (c) {
          var k = 'state:' + c.id;
          var cur = pj(lg(k));
          if (cur && cur.rewardId) return;
          var same = (c.rewards || []).filter(function (r) { return r.code === prev.code; })[0];
          if (same) {
            ls(k, JSON.stringify({
              rewardId: same.id, code: same.code, ts: prev.ts || Date.now(),
              unlocked: !!prev.unlocked, emailSent: !!prev.emailSent, email: prev.email || ''
            }));
          } else {
            mismatch = true;
          }
        });
      }
      if (prev.unlocked || mismatch) { hide(prev.unlocked ? 'already_unlocked' : 'already_scratched'); return; }
    }

    if (lg('known') === '1') { hide('known_profile'); return; }

    /* 3) Perfil identificado por Klaviyo */
    var tries = 0;
    (function check() {
      var k = window.klaviyo;
      if (k && typeof k.isIdentified === 'function') {
        try {
          Promise.resolve(k.isIdentified()).then(function (id) {
            if (id) { ls('known', '1'); hide('klaviyo_identified'); }
          }).catch(function () {});
        } catch (e) {}
        return;
      }
      if (++tries < 24) window.setTimeout(check, 250);
    })();
  } catch (e) { /* nunca romper el popup */ }
})();
